import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { format } from 'date-fns';

import { getDate } from '../../configInfo/components/Functions';

import { UserClientCardProps } from './UserClientCardProps';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';

interface Props {
  cardProps: UserClientCardProps;
  delay: number;
}

const UserClientCard: React.FC<Props> = ({ cardProps, delay }) => {
  let dateCreated = format(getDate(new Date(cardProps.createdUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');
  let dateLastUpdate = format(getDate(new Date(cardProps.lastUpdatedUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');

  return (
    <div className="card">
      <Card sx={{ cursor: 'pointer' }}>
        <CardContent>
          <Typography variant="h6">
            <b>User Client UId: </b>
            {cardProps.userClientUId}
          </Typography>
          <br></br>
          <Typography variant="body1">
            <b>Email: </b>
            {cardProps.email || 'N/A'}
          </Typography>
          <Typography variant="body1">
            <b>{cardProps.isEmailVerified ? 'Email Verified' : 'Email Not Verified'}</b>
          </Typography>
          <Typography variant="body1">
            <b>{cardProps.isPartner ? 'Is Partner' : 'Is not a Partner'}</b>
          </Typography>
          <Typography variant="body1">
            <b>IP Address: </b>
            {cardProps.ipAddress}
          </Typography>
          <Typography variant="body1">
            <b>User Agent: </b>
            {cardProps.userAgent}
          </Typography>
          <Typography variant="body1">
            <b>Created: </b>
            {dateCreated}
          </Typography>
          <Typography variant="body1">
            <b>Last Updated: </b>
            {dateLastUpdate}
          </Typography>
          <br></br>
          <Typography variant="body1">
            <b>User Client Attributions: </b>
            {cardProps.userClientAttributions.length > 0
              ? cardProps.userClientAttributions.map((attribution, i) => (
                  <>
                    <Box className={'attributionSessionRow'} key={i}>
                      <Box>
                        <b>Type: </b>
                        {attribution.type}
                      </Box>
                      <Box>
                        <b>Identifier: </b>
                        {attribution.identifier}
                      </Box>
                      <Box>
                        <b>Display Value: </b>
                        {attribution.displayValue}
                      </Box>
                    </Box>
                    <Divider />
                  </>
                ))
              : 'N/A'}
          </Typography>
          <br></br>
          <Typography variant="body1">
            <b>User Client Applications: </b>
            {cardProps.userClientSessions.length > 0
              ? cardProps.userClientSessions.map((session, i) => (
                  <>
                    <Box className={'attributionSessionRow'} key={i}>
                      <Box>
                        <b>ApplicationUid: </b>
                        {session.sessionUid}
                      </Box>
                      <Box>
                        <b>ConfigName: </b>
                        {session.configName}
                      </Box>
                      <Typography variant="body1">
                        <b>{session.isOptedOut ? 'Opted Out' : 'Opted In'}</b>
                      </Typography>
                      <Typography variant="body1">
                        <b>{session.isDisqualified ? 'Disqualified' : 'Not Disqualified'}</b>
                      </Typography>
                      <Typography variant="body1">
                        <b>{session.isCompleted ? 'Completed' : 'Not Completed'}</b>
                      </Typography>
                      <Typography variant="body1">
                        <b>{session.isLeadConverted ? 'Lead is Converted' : 'Lead Not Converted'}</b>
                      </Typography>
                      {session.isPartner && (
                        <Typography variant="body1">
                          <b>Partner UserClient Application</b>
                        </Typography>
                      )}
                      <Typography variant="body1">
                        <b>Company Name JSON: </b>
                        <pre>{JSON.stringify(JSON.parse(session.companyNameJson), null, 2)}</pre>
                      </Typography>
                    </Box>
                    <Divider />
                  </>
                ))
              : 'N/A'}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserClientCard;
